import chineseFood from '../../assets/img/chinese-food.svg';

const data = {
  title: '50% of full range of Chinese food',
  expirationText: 'Valid until June 10',
  image: chineseFood,
};

export default data;
